import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../../../supabaseClient';
import Icon from '../../../components/AppIcon';

const NavigationCards = () => {
  const [schoolCount, setSchoolCount] = useState(0);

  // On récupère le nombre réel d'écoles pour l'afficher dans le badge
  useEffect(() => {
    const fetchCount = async () => {
        const { count } = await supabase.from('schools').select('*', { count: 'exact', head: true });
        setSchoolCount(count || 50); // Fallback à 50 si erreur
    };
    fetchCount();
  }, []);

  const navigationItems = [
    {
      title: "Orientation Lycée",
      description: "Explorez les filières du baccalauréat et découvrez les matières et débouchés de chaque spécialisation",
      icon: "GraduationCap",
      path: "/lycee-orientation",
      color: "bg-blue-500",
      bgColor: "bg-blue-50",
      stats: "Bac Marocain"
    },
    {
      title: "Écoles & Universités",
      description: "Base de données complète des établissements post-bac (ENCG, ENSA, FMP...) avec seuils d'admission.",
      icon: "School",
      path: "/post-bac-database",
      color: "bg-green-500",
      bgColor: "bg-green-50",
      // ICI : On affiche le vrai nombre
      stats: schoolCount > 0 ? `+${schoolCount} établissements` : "Chargement..."
    },
    {
      title: "Calendrier d'Admission",
      description: "Suivez toutes les dates importantes : inscriptions, concours d'entrée et publication des résultats",
      icon: "Calendar",
      path: "/admission-calendar",
      color: "bg-purple-500",
      bgColor: "bg-purple-50",
      stats: "Dates 2025"
    },
    {
      title: "Mon Profil Étudiant",
      description: "Créez votre profil pour recevoir des recommandations personnalisées basées sur vos notes.",
      icon: "User",
      path: "/student-profile",
      color: "bg-orange-500",
      bgColor: "bg-orange-50",
      stats: "100% Personnalisé"
    }
  ];

  return (
    <section className="py-16 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-heading font-bold text-foreground mb-4">
            Explorez Vos Options d'Orientation
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Accédez à tous les outils nécessaires pour faire les meilleurs choix académiques 
            et construire votre parcours éducatif au Maroc
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {navigationItems.map((item, index) => (
            <Link
              key={index}
              to={item.path}
              className="group block h-full"
            >
              <div className={`${item.bgColor} rounded-2xl p-6 h-full transition-all duration-300 hover:shadow-interactive hover:scale-105 border border-border/50 flex flex-col`}>
                <div className="space-y-4 flex flex-col h-full">
                  {/* Icon */}
                  <div className={`w-12 h-12 ${item.color} rounded-xl flex items-center justify-center text-white group-hover:scale-110 transition-transform`}>
                    <Icon name={item.icon} size={24} />
                  </div>

                  {/* Content */}
                  <div className="space-y-2 flex-grow">
                    <h3 className="text-xl font-heading font-semibold text-foreground group-hover:text-primary transition-colors">
                      {item.title}
                    </h3>
                    <p className="text-sm text-muted-foreground leading-relaxed">
                      {item.description}
                    </p>
                  </div>

                  {/* Stats */}
                  <div className="flex items-center justify-between pt-4 mt-auto">
                    <span className="text-xs font-medium text-primary bg-white/80 px-3 py-1 rounded-full shadow-sm">
                      {item.stats}
                    </span>
                    <Icon 
                      name="ArrowRight" 
                      size={16} 
                      className="text-muted-foreground group-hover:text-primary group-hover:translate-x-1 transition-all" 
                    />
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NavigationCards;